import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface LightboxPage {
  src: string;
  caption: string;
}
interface PageLightboxProps {
  page: LightboxPage | null;
  onClose: () => void;
}

/** Full-size view of a real product page. */
export function PageLightbox({
  page,
  onClose
}: PageLightboxProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!page) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    closeRef.current?.focus();
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [page, onClose]);
  if (!page) return null;
  return <div role="dialog" aria-modal="true" aria-label={page.caption} onClick={onClose} className="fixed inset-0 z-50 flex items-center justify-center bg-brand-charcoal/85 p-4" data-id="element-34" data-mp="q1mbz4pqlcrl">
      <button ref={closeRef} type="button" onClick={onClose} aria-label="Chiudi" className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-white text-brand-charcoal transition-transform duration-150 ease-out active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta" data-id="element-35" data-mp="157f14u3a5bo1">
        <XIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-36" data-mp="hg9log194le9" />
      </button>
      <figure onClick={event => event.stopPropagation()} className="flex max-h-full flex-col items-center" data-id="element-37" data-mp="mf2uhv5lfo83">
        <img src={page.src} alt={`${page.caption} — pagina reale di Lash & Brow Instructor Ready`} className="block max-h-[82vh] w-auto max-w-full rounded-[14px] bg-white object-contain" data-id="element-38" data-mp="qgy0hcygyps7" />
        <figcaption className="mt-3 text-center font-body text-[12px] font-semibold uppercase tracking-[0.14em] text-brand-ivory/85" data-id="element-39" data-mp="2soea9xcg00j">
          {page.caption}
        </figcaption>
      </figure>
    </div>;
}